import LegalEntityFormFields from './LegalEntityFormFields';

export default LegalEntityFormFields;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/components/upsert-watch-list-entry-form/legal-entity-form-fields/index.js